import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { TimelineItem, ActiveFunctions, ItemFilters, AnchorMonth } from '@/types/item';

interface SortableItemRowProps {
  item: TimelineItem;
  children: React.ReactNode;
  isOverlay?: boolean;
}

const SortableItemRow: React.FC<SortableItemRowProps> = ({
  item,
  children,
  isOverlay = false
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ 
    id: item.id,
    disabled: isOverlay
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div 
      ref={setNodeRef} 
      style={style}
      className={`relative ${isDragging ? 'z-50' : ''}`}
      {...attributes}
      {...listeners}
    >
      {children}
    </div>
  );
};

export default SortableItemRow;